import { onLogout } from '../../actions/auth';
import { connect } from 'react-redux';
import Navbar from './NavBar';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    dispatch(onLogout());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
